var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutscanLcrShipment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_9325)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1562_9325)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1562_9325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H9.2C4.11898 0 0 4.11898 0 9.2V70C0 75.081 4.11898 79.2 9.2 79.2H70C75.081 79.2 79.2 75.081 79.2 70V9.2C79.2 4.11898 75.081 0 70 0Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 47.0321V47.8403H11.4572V50.3262H12.1803V47.8403H19.7926L20.2814 47.0321H9Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9612 47.0297H63.5542L64.0411 47.8379H69.9612V47.0297Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5083 47.0312H51.6973V25.1215H50.5083V47.0312Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0943 23.0008H9V37.7793H49.0943V23.0008Z",
    fill: "#72A1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.961 37.6507L64.1672 28.5265H51.6968V37.7793H69.961V37.6507Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0943 47.0312V37.7796H9V47.0312H49.0943Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1465 30.3913V34.5645L57.3208 30.3913H53.1465Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2286 30.391L53.1465 36.4719V36.5586H54.4225L60.5913 30.391H59.2286Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4753 30.7792L57.6943 36.5586H60.6521L64.6231 32.5887L63.4753 30.7792Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3656 33.7551L62.5605 36.5586H63.9236L65.8936 34.5882L65.3656 33.7551Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3208 30.3897L53.1465 34.5629V36.4707L59.2286 30.3897H57.3208Z",
    fill: "#72A1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.228 30.391H60.5916L54.4229 36.5586H57.6941L63.4751 30.7792L63.228 30.391Z",
    fill: "#72A1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6229 32.5887L60.6519 36.5586H62.5604L65.3655 33.7551L64.6229 32.5887Z",
    fill: "#72A1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8929 34.5882L63.9229 36.5586H67.144L65.8929 34.5882Z",
    fill: "#72A1DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.961 37.7792H51.6968V43.0469H69.961V37.7792Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6968 47.0312H69.961V45.0402H51.6968V47.0312Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6968 43.0481V45.041H69.961V43.0481H51.6968Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9701 41.4902H53.1465V39.1309H57.9701V41.4902Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0034 40.8984H54.1113V39.7188H57.0034V40.8984Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0046 42.0822H69.9609V46.002H71.0046V42.0822Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6351 47.6052H69.9609V49.5664H70.6351V47.6052Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7365 47.0297H9V47.8379H69.9612V47.0297H56.7365Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9613 47.8399H14.5259V50.041H69.9613V47.8399Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8392 46.7367H20.5318L19.1753 48.9775L18.5322 50.041H28.8376L28.1953 48.9775L26.8392 46.7367Z",
    fill: "#DCDBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4782 52.2056C28.4782 54.8537 26.3322 57 23.6858 57C21.0377 57 18.8921 54.8537 18.8921 52.2056C18.8921 49.5583 21.0377 47.4128 23.6858 47.4128C26.3322 47.4128 28.4782 49.5583 28.4782 52.2056Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2364 52.2046C26.2364 53.6148 25.0936 54.7559 23.6862 54.7559C22.2762 54.7559 21.1338 53.6148 21.1338 52.2046C21.1338 50.796 22.2762 49.6549 23.6862 49.6549C25.0936 49.6549 26.2364 50.796 26.2364 52.2046Z",
    fill: "#DCDBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5612 52.2058C24.5612 52.6892 24.1692 53.084 23.6866 53.084C23.202 53.084 22.8096 52.6892 22.8096 52.2058C22.8096 51.722 23.202 51.3297 23.6866 51.3297C24.1692 51.3297 24.5612 51.722 24.5612 52.2058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2409 49.3171L29.0361 48.9774L28.2535 47.6835L27.6808 46.7367L27.2169 46.0042H20.0996L19.6885 46.7367L19.1158 47.6835L18.334 48.9774L18.1284 49.3171L16.8994 51.3508L17.5161 51.7207L18.9697 49.3171L19.1748 48.9774L19.9585 47.6835L20.5313 46.7367H26.8388L27.4119 47.6835L28.1949 48.9774L28.3996 49.3171L29.8532 51.7207L30.4703 51.3508L29.2409 49.3171Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7451 46.7367H57.4368L56.0804 48.9775L55.4385 50.041H65.7431L65.1004 48.9775L63.7451 46.7367Z",
    fill: "#DCDBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3838 52.2056C65.3838 54.8537 63.2386 57 60.5917 57C57.9437 57 55.7988 54.8537 55.7988 52.2056C55.7988 49.5583 57.9437 47.4128 60.5917 47.4128C63.2386 47.4128 65.3838 49.5583 65.3838 52.2056Z",
    fill: "#262427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1412 52.2046C63.1412 53.6148 61.9996 54.7559 60.5914 54.7559C59.1817 54.7559 58.0405 53.6148 58.0405 52.2046C58.0405 50.796 59.1817 49.6549 60.5914 49.6549C61.9996 49.6549 63.1412 50.796 63.1412 52.2046Z",
    fill: "#DCDBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4671 52.2058C61.4671 52.6892 61.0754 53.084 60.5916 53.084C60.1087 53.084 59.7158 52.6892 59.7158 52.2058C59.7158 51.722 60.1087 51.3297 60.5916 51.3297C61.0754 51.3297 61.4671 51.722 61.4671 52.2058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1467 49.3171L65.9423 48.9774L65.1598 47.6835L64.587 46.7367L64.1239 46.0042H57.0059L56.5955 46.7367L56.0228 47.6835L55.2402 48.9774L55.0355 49.3171L53.8057 51.3508L54.4227 51.7207L55.8759 49.3171L56.0807 48.9774L56.8648 47.6835L57.4372 46.7367H63.7454L64.3174 47.6835L65.1007 48.9774L65.3067 49.3171L66.7599 51.7207L67.3765 51.3508L66.1467 49.3171Z",
    fill: "#262427"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_9325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1562_9325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1562_9325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutscanLcrShipment);
export default __webpack_public_path__ + "static/media/outscanLcrShipment.9dfe5eb67c333bd8a2842e5b5ed33912.svg";
export { ForwardRef as ReactComponent };